module.exports = __webpack_public_path__ + "img/home2.6792aec0.png";